import { Autocomplete, Button, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useSetProjectPoint, useSetProjectTimeInit } from "../../interfaces/point";
import { useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "../../interfaces/modal";

const MainWrap = styled.div`
    display: flex;
    flex-direction: column;
    padding:0 0.5rem;
    height: 100%;
    .row {
        padding-top: 0.8rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0.5rem;
    }
`;

const PointDetail = ({sid, detail, pointTpList }) => {

    const queryClient = useQueryClient();
    const [target, setTarget] = useState();

    const {mutate} = useSetProjectPoint();
    const {mutate:timeInitMutate} = useSetProjectTimeInit();

    const initTemp = {
        sid:sid,
        sno:'',
        snm:'',
        point_tp_nm: '',
        way_cnt:'',
        dir_cnt:'',
        pos_addr:'',
        pos_gps:'',
        pos_etc:''

    }
    useEffect(()=>{
        (detail && detail.tid>0) ? setTarget(detail) : setTarget(initTemp);
    },[detail])

    const handleValueChange = (id, val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAutoValueChange = (id,val1,id2,val2) => {
        const temp  = {...target,[id]:val1,[id2]:val2}
        setTarget(temp);
    }

    const handleUpdateClick = useCallback((updateItem) => {
        const temp = {
            mode: 'POST',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    )
                    // onClickAway(false);
                }
            }
            )
    })

    const handleDeleteClick = (updateItem) => {
        queryClient.setQueryData(
            [MODAL_QUERY_NM],
            {
                show:true,
                msg:'삭제하시겠습니까?',
                height:'20vh',
                okButton:()=>confirmDelete(updateItem)
            }
        )
    }

    const confirmDelete = useCallback((updateItem) => {
        const temp = {
            mode: 'DELETE',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleTimeInitClick = useCallback((tid) => {
        const temp = {
            mode: 'ALL',
            sid:sid,
            tid:tid
        }
        timeInitMutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'초기화하였습니다.',
                            height:'20vh',
                        }
                    )
                    // onClickAway(false);
                }
            }
            )
    })

    return (
        <MainWrap>
            <div style={{flexGrow:1, overflow:'auto'}}>
                <div className="row">
                    <TextField
                        id='sno'
                        label='지점표기번호'
                        size='small'
                        style={{width:'15rem'}} 
                        InputLabelProps={{shrink:true}}
                        value={target && target.sno}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    />
                    <TextField
                        id='snm'
                        label='지점명'
                        size='small'
                        style={{width:'15rem'}} 
                        InputLabelProps={{shrink:true}}
                        value={target && target.snm}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    />
                </div>
                <div className="row">
                    <Autocomplete
                        id="point_tp_nm"
                        size='small'
                        options={pointTpList}
                        sx={{ width: 180 }}
                        value={target && target.point_tp_nm.length > 0 ? target.point_tp_nm: ''}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{shrink:true}} label="지점 유형" />}
                        onChange={(e,v)=>(v!==null)&&handleAutoValueChange('point_tp',v.code,'point_tp_nm',v.value)}
                    />
                    <TextField
                        id='way_cnt'
                        label='도로수'
                        size='small'
                        style={{width:'5rem'}} 
                        InputLabelProps={{shrink:true}} 
                        value={target && target.way_cnt}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    />
                    {/* <TextField
                        id='dir_cnt'
                        label='방향수'
                        size='small'
                        style={{width:'5rem'}} 
                        InputLabelProps={{shrink:true}} 
                        value={target && target.dir_cnt}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    /> */}
                </div>
                <div className="row">
                    <TextField
                        id='pos_addr'
                        label='위치-주소'
                        size='small'
                        style={{width:'25rem'}} 
                        InputLabelProps={{shrink:true}} 
                        value={target && target.pos_addr}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    />
                </div>
                <div className="row">
                    <TextField
                        id='pos_gps'
                        label='위치-GPS'
                        size='small'
                        style={{width:'25rem'}} 
                        InputLabelProps={{shrink:true}} 
                        value={target && target.pos_gps}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    />
                </div>
                <div className="row" style={{flexGrow:1, alignItems:'start'}}>
                    <TextField
                        id='pos_etc'
                        label='위치-기타'
                        size='small'
                        style={{width:'25rem'}} 
                        InputLabelProps={{shrink:true}} 
                        value={target && target.pos_etc}
                        onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                    />
                </div>
            </div>
            <div className="row">
                <Button variant="contained" style={{width:'100%'}} onClick={()=>handleUpdateClick(target)}>{(detail && detail.tid>0) ? '수정':'등록'}</Button>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>handleTimeInitClick(detail.tid)}>시간 초기화</Button>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>handleDeleteClick(target)}>삭제</Button>
            </div>
        </MainWrap>
    )
}

export default PointDetail;